<template>
  <section>
    <div style="text-align:center;">
      <img src="@/static/images/icp.jpg" />
    </div>
  </section>
</template>

<script>
import NavComponent from '@/components/Nav'
import FooterComponent from '@/components/Footer'
import { mapActions } from 'vuex'
import commonMixin from '@/mixin/common'
export default {
  name: 'IcpPage',
  data () {
    return {
    }
  },
}
</script>
